import React from "react";

import { Preview } from "@creatomate/preview";
import { Button, Icon } from "@culturehq/components";
import { Trans } from "app/utils";

interface SelectAudioProps {
  preview: Preview;
}

const SelectAudio: React.FC<SelectAudioProps> = ({ preview }) => {
  const handleAddAudio = () => {
    preview.setActiveElements([]);
  };

  return (
    <Button inverted onClick={handleAddAudio}>
      <Icon icon="ios-plus" /><Trans>Add Audio</Trans>
    </Button>
  );
};

export default SelectAudio;
